<template>
    <div class="add-article">
        <router-view></router-view>

        <div class="floating-card">
            <div class="add-article__close-button">
                <icon-button @click="close">
                    close
                </icon-button>
            </div>

            <div class="floating-card__inner">
                <text-field label="Artikelnummer"
                            v-model="articleNumber"
                            class="add-article__number-input"
                />

                <default-button :variations="['full-width']" @click="submitChanges()">
                    Speichern
                </default-button>
            </div>
        </div>
    </div>
</template>

<script>
import DefaultButton from '../common/default-button';
import IconButton from '../common/icon-button';
import TextField from '../common/text-field';

export default {
    components: {
        IconButton,
        DefaultButton,
        TextField
    },
    data() {
        return {
            articleNumber: ''
        }
    },
    computed: {
        userStao() {
            return this.$store.getters['user/userStao'];
        }
    },
    watch: {
        artDetails: function() {
            this.nowTime = (new Date()).getTime();
        }
    },
    methods: {
        close() {
            this.$router.go(-1);
        },

        submitChanges() {
            this.$store.dispatch('fotodatenbank/addArt', {
                artnum: this.articleNumber,
                stao: this.userStao
            });
        }
    }
}
</script>

<style scoped lang="scss">
.add-article__close-button {
    position: absolute;
    top: 0.5rem;
    right: 0.5rem;
    cursor: pointer;
    font-size: 2.5rem;
    z-index: 999;
}

.add-article{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    /*background-color: blue;*/
}

.floating-card {
    @include default-shadow;
    position: relative;
    display: flex;
    flex-direction: column;
    max-width: 100%;
    max-height: 90vh;
    background-color: $color-white;
    padding: 1rem;
    overflow-y: auto;

    @include medium {
            width: 31rem;
    }

    @include extra-large {
        width: auto;
        max-width: 90%;
    }
}

.floating-card__inner {
    display: flex;
    flex-direction: column;
    width: 100%;
    padding-top: 2.5rem;
}

.add-article__number-input{
    width: 300px;
    margin-bottom: 1rem;
}

</style>
